import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { BaySearchOption } from "../Enums/bay-search-enum";
import { MapSearchService } from "../../../../shared/services/map-search/map-search.service";
import { ArcGisBayColumn } from "../models/arcgis-bay-column.model";
import { SessionStorageService } from "../../../../shared/services/storage/session-storage.service";
import { SearchTableService } from "../../../../shared/services/table-column-mapping/search-table.service";
import { HttpClient } from "@angular/common/http";
import { RequestStatusService } from "../../../../shared/services/request-status/request-status.service";
import { Router } from "@angular/router";
import _ from "underscore";
import { SearchContainerHeight } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { AppRoutingConstants } from "../../../../app-routing.constants";
import { CreateApplicationRoutingConstants } from "../../../../application/create-application/create-application-routing.constants";
import GeometryUtils from "../../../../shared/utils/geometry-utils";
let BaySearchService = class BaySearchService extends MapSearchService {
    sessionStorageService;
    searchTableService;
    http;
    requestStatusService;
    router;
    bayUrl;
    baySearchType;
    arcGisBayOutColumnList;
    // @ts-ignore
    arcGisPropertyOutColumnList;
    bayList = new BehaviorSubject(null);
    bayListAsObservable = this.bayList.asObservable();
    baySearchTableColumnMap = new BehaviorSubject(null);
    baySearchTableColumnMapObservable = this.baySearchTableColumnMap.asObservable();
    searchOptionsMap;
    selectedSearchOptionLookup;
    constructor(sessionStorageService, searchTableService, http, requestStatusService, router) {
        super(sessionStorageService, searchTableService);
        this.sessionStorageService = sessionStorageService;
        this.searchTableService = searchTableService;
        this.http = http;
        this.requestStatusService = requestStatusService;
        this.router = router;
        this.mapLocationAsObservable = this.mapLocation.asObservable();
    }
    setBayList(bayList) {
        this.bayList.next(bayList);
    }
    clearURLList() {
        this.bayUrl = "";
    }
    setURL(searchType, url) {
        switch (searchType) {
            case BaySearchOption.Bay:
                this.bayUrl = url;
                break;
        }
    }
    setSearchOptionLookup(searchEnum) {
        this.searchOptionsMap = new Map();
        for (const [key, value] of Object.entries(searchEnum)) {
            // @ts-ignore
            this.searchOptionsMap.set(key, value);
        }
    }
    setSelectedSearchOption(searchOption) {
        this.selectedSearchOptionLookup = this.getSearchOptionLookup(searchOption);
        this.baySearchType = BaySearchOption.Bay;
    }
    getSearchOptionLookup(selectedSearchOption) {
        const keys = [...this.searchOptionsMap.entries()]
            .filter(({ 1: v }) => v === selectedSearchOption)
            .map(([k]) => k);
        return keys.length > 0 ? keys[0].toString() : selectedSearchOption;
    }
    setTableColumnMap(tableColumnMap) {
        this.baySearchTableColumnMap.next(tableColumnMap);
    }
    clearTableColumnMap() {
        this.baySearchTableColumnMap.next(new Map());
    }
    getLayerUrl(searchType) {
        switch (searchType) {
            case BaySearchOption.Bay:
                return this.bayUrl;
            default:
                return this.bayUrl;
        }
    }
    // @ts-ignore
    transformFeature(feature, searchOption) {
        switch (searchOption ? searchOption : this.baySearchType) {
            case BaySearchOption.Bay:
                return {
                    id: feature.attributes.OBJECTID ? feature.attributes.OBJECTID : (feature.attributes.objectid ? feature.attributes.objectid : null),
                    sgCode: feature.attributes.SgCode ? feature.attributes.SgCode : (feature.attributes.sgcode ? feature.attributes.sgcode : null),
                    size: feature.attributes.Size ? feature.attributes.Size : (feature.attributes.size ? feature.attributes.size : null),
                    status: feature.attributes.Status ? feature.attributes.Status : (feature.attributes.status ? feature.attributes.status : null),
                    tradingSiteDescription: feature.attributes.TradingSiteDescription ? feature.attributes.TradingSiteDescription : (feature.attributes.tradingsitedescription ? feature.attributes.tradingsitedescription : null),
                    tradingSiteStatus: feature.attributes.TradingSiteStatus ? feature.attributes.TradingSiteStatus : (feature.attributes.tradingsitestatus ? feature.attributes.tradingsitestatus : null),
                    tradingSiteTown: feature.attributes.TradingSiteTown ? feature.attributes.TradingSiteTown : (feature.attributes.tradingsitetown ? feature.attributes.tradingsitetown : null),
                    geometry: feature.geometry ? GeometryUtils.mapGeometryToDTO(feature.geometry) : (feature.attributes.Geometry ? GeometryUtils.mapGeometryToDTO(feature.geometry) : null)
                };
        }
    }
    getAttributeListForSearchType(searchOption) {
        switch (searchOption ? searchOption : this.searchType) {
            case BaySearchOption.Bay:
                return [..._.values(this.arcGisBayOutColumnList)];
        }
    }
    // build links for map locator and create application request
    addMapLocatorLinks(baysFound) {
        baysFound.forEach((bay) => {
            bay.link = this.setMapLink(bay, SearchContainerHeight.BaysLocationMap);
            // bay.link2 = this.setCreateApplicationLink(bay);
        });
        this.setBayList(baysFound);
    }
    setMapLink(bay, height) {
        return {
            text: SharedConstants.VIEW_ON_MAP_TEXT,
            address: "",
            clickAction: (link) => {
                this.changeMapLocation(String(bay.id), height);
            }
        };
    }
    setCreateApplicationLink(bay) {
        return {
            text: SharedConstants.CREATE_APPLICATION_TEXT,
            address: "",
            clickAction: (link) => {
                this.startApplicationSelectedBay(bay);
            }
        };
    }
    clearBaysList() {
        this.bayList.next([]);
    }
    startApplicationSelectedBay(bay) {
        const url = this.getLayerUrl(BaySearchOption.Bay);
        // @ts-ignore
        this.doSearch(url, bay.id.toString(), ArcGisBayColumn.Id, true, BaySearchOption.Bay, true, true).then((result) => {
            if (result.length > 0) {
                this.router.navigate([this.getStartApplicationRoute()], { state: { propertyData: JSON.stringify(result[0]) } }).then();
            }
        });
    }
    getStartApplicationRoute() {
        const route = AppRoutingConstants.createRouteToView(this.getSelectedSystemModule() + "", CreateApplicationRoutingConstants.CREATE_APPLICATION_ROUTE, CreateApplicationRoutingConstants.DETAILS_ROUTE);
        const emptySpaceRe = new RegExp(" ", "gi");
        return route.replace(emptySpaceRe, "");
    }
    static ctorParameters = () => [
        { type: SessionStorageService },
        { type: SearchTableService },
        { type: HttpClient },
        { type: RequestStatusService },
        { type: Router }
    ];
};
BaySearchService = __decorate([
    Injectable({
        providedIn: "root"
    })
], BaySearchService);
export { BaySearchService };
